{
  "Earlier": "PLUS TÔT",
  "noAnnouncements": "Vous recevrez des informations sur les activités de maintenance planifiées et sur les problèmes relatifs aux produits en cours de résolution",
  "noAnnouncementsTitle": "Vos annonces apparaîtront ici"
}
